import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import classNames from 'classnames';
import classes from './SiteNavBMobileLevelB.module.scss';

const SiteNavBMobileLevelB = (props) => {
  const {
    mainNavItems = [],
    globalNavLinks = [],
    onMenuItemClick,
    scroll,
    contactHref,
    signIn = {},
  } = props;

  const {
    title: signInTitle,
    href: signInHref,
    target: signInTarget,
  } = signIn;

  return (
    <div className={classNames(classes.container, !scroll && classes.noScroll)}>
      <div className={classes.topMenu}>
        <div className={classes.menuWrapper}>
          {mainNavItems.map((item, index) => {
            const {
              isVisible: treeItemIsVisible,
              heading: treeItemHeading,
              href: treeItemHref,
              target: treeItemTarget,
              items: treeItemItems = [],
            } = item;

            return (
              treeItemIsVisible && treeItemHeading && (
                <div key={`button-${index}`} className={classes.menuHeading}>
                  {treeItemItems.length > 0 ? (
                    <button
                      aria-label={`${item.heading}-nav-button`}
                      className={classes.menuHeadingButton}
                      onClick={() => onMenuItemClick(item)}
                      type='button'
                    >
                      <div
                        className={classes.menuHeadingTitle}
                        dangerouslySetInnerHTML={{ __html: treeItemHeading }}
                      />
                    </button>
                  ) : (
                    <Link
                      href={treeItemHref}
                      target={treeItemTarget}
                      className={classes.menuHeadingButton}
                    >
                      <div
                        className={classes.menuHeadingTitle}
                        dangerouslySetInnerHTML={{ __html: treeItemHeading }}
                      />
                    </Link>
                  )}
                </div>
              )
            );
          })}
        </div>
      </div>
      <div className={classes.middleMenu}>
        {globalNavLinks.map(({
          isVisible,
          href,
          target,
          heading,
        }, index) => (
          isVisible && href &&
          <div key={`mobile-global-link-${index}`} className={classes.globalNavLinkContainer}>
            <Link
              className={classes.globalNavLink}
              href={href}
              target={target}
              dangerouslySetInnerHTML={{ __html: heading }}
            />
          </div>
        ))}
      </div>
      <div className={classes.bottomMenu}>
        <div className={classes.menuWrapper}>
          {signIn &&
            <div className={classes.bottomNavLinkContainer}>
              <Link
                title={signInTitle}
                className={classes.bottomNavLink}
                href={signInHref}
                target={signInTarget}
              />
            </div>}
          {contactHref &&
            <div className={classes.bottomNavLinkContainer}>
              <Link
                title='Help &amp; Feedback'
                className={classes.bottomNavLink}
                href={contactHref}
              />
            </div>}
        </div>
      </div>
    </div>
  );
};

const TGlobalNavLink = PropTypes.shape({
  isVisible: PropTypes.bool,
  heading: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
});

const TMainNavItem = PropTypes.shape({
  isVisible: PropTypes.bool,
  heading: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  items: PropTypes.array,
});

const TSignIn = PropTypes.shape({
  title: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
});

SiteNavBMobileLevelB.propTypes = {
  mainNavItems: PropTypes.arrayOf(TMainNavItem),
  globalNavLinks: PropTypes.arrayOf(TGlobalNavLink),
  onMenuItemClick: PropTypes.func,
  scroll: PropTypes.bool,
  contactHref: PropTypes.string,
  signIn: PropTypes.shape(TSignIn),
};

export default SiteNavBMobileLevelB;
